module.exports = __webpack_public_path__ + "static/9c27a9bd2390222f0c26648d81b335aa43c176fceacdd0ad6c0fa95ebfeb402b-7279d94e4c8e5f600c03278ff1b8d22e.jpeg";